import { equal } from '@ember/object/computed';
import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import Enum from '@square/dashboard-utilities/utils/enum';
export const SelectionType = new Enum(['SINGLE', 'MULTIPLE']);
export default ProtoBaseModel.extend({
  id: attr(String),
  name: attr(String),
  ordinal: attr(Number),
  selectionType: attr(SelectionType),
  isSingleSelection: equal('selectionType', SelectionType.SINGLE),
  isMultipleSelection: equal('selectionType', SelectionType.MULTIPLE),
  catalogObjectReference: attr(CatalogObjectReference)
}).reopenClass({
  createFor(itemModifierList) {
    return this.create({
      id: itemModifierList.get('id'),
      name: itemModifierList.get('name'),
      ordinal: itemModifierList.get('ordinal'),
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(itemModifierList)
    });
  }
});